export default __webpack_public_path__ + "static/media/onboarding-mobile.2cdd2468.png";